import { render, staticRenderFns } from "./BlockValue.vue?vue&type=template&id=7c228110&"
import script from "./BlockValue.vue?vue&type=script&lang=js&"
export * from "./BlockValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports